"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringUtil = void 0;
var StringBuilder_1 = require("./StringBuilder");
var C_ESC_CHAR = '\'"`\\\b\f\n\r\t';
var C_ESC_SYMB = '\'"`\\bfnrt';
var MIN_PRINTABLE_CHAR = ' ';
var StringUtil = /** @class */ (function () {
    function StringUtil() {
    }
    StringUtil.isJavaIdentifier = function (str) {
        if (str == null || str.length < 1)
            return false;
        return !!str.match('^[a-zA-Z_$][0-9a-zA-Z_$]*$');
    };
    /**
     * Escape a String using the C style
     * e.g. for string "It's a example" escape to "It\'s a example");
     * This is used by (Java/Javascript/C/C++)Code generator
     *
     * @param str the string to be escaped
     * @param quoteChar The quote char
     * @return The escaped String
     */
    StringUtil.cEscape = function (str, quoteChar) {
        if (str === void 0) { str = ''; }
        if (quoteChar === void 0) { quoteChar = '"'; }
        if (!str)
            return str;
        // First scan to check if it needs escape just to avoid create new String object for better performance.
        for (var i = 0;; i++) {
            if (i === str.length)
                return str;
            var c = str.charAt(i);
            if (c < MIN_PRINTABLE_CHAR || C_ESC_CHAR.indexOf(c) >= 0)
                break;
        }
        // Second scan, Do escape
        var result = new StringBuilder_1.StringBuilder();
        for (var i = 0; i < str.length; i++) {
            var c = str.charAt(i);
            // check if it's a special printable char
            var idx = C_ESC_CHAR.indexOf(c);
            if (idx >= 3 || quoteChar === c) {
                // first 3 chars are quote chars
                result.append('\\');
                result.append(C_ESC_SYMB.charAt(idx));
            }
            else if (c < MIN_PRINTABLE_CHAR) {
                // check if it's a un-printable char
                result.append('\\u');
                result.append(c.charCodeAt(0).toString(16).padStart(4, '0'));
            }
            else
                result.append(c);
        }
        return result.toString();
    };
    StringUtil.repeat = function (str, times) {
        return ''.padEnd(str.length * times, str);
    };
    StringUtil.contains = function (str, pattern) {
        return str.indexOf(pattern) >= 0;
    };
    return StringUtil;
}());
exports.StringUtil = StringUtil;
//# sourceMappingURL=StringUtil.js.map